import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InitCart } from '@app/store/actions/cart.action';
import { ConfigService, NotificationService } from '@infomaniak/angular-common';
import { Store } from '@ngxs/store';
import { InvitationB2bClientService, INVITATIONB2BCLIENTSTEPSTYPE, TInvitationB2BClientSteps } from './invitation-b2b-client.service';
import { translate } from '@ngneat/transloco';

@Component({
  selector: 'app-invitation-b2b-client',
  templateUrl: './invitation-b2b-client.component.html',
  styleUrls: ['./invitation-b2b-client.component.scss']
})
export class InvitationB2bClientComponent implements OnInit {
  @Input() invitation: any;

  rejectLoading = false;
  acceptLoading = false;
  invitationStep = INVITATIONB2BCLIENTSTEPSTYPE;
  currentInvitationStep: TInvitationB2BClientSteps = this.invitationStep.invitationB2bInit;
  confirmationCheckbox = false;

  selectedAccount: any;
  selectedPermission: 'limited' | 'full';
  selectedPayment: 'customer' | 'partner';
  partnershipId: number;

  constructor(
    private configService: ConfigService,
    private invitationB2bClientService: InvitationB2bClientService,
    protected dialog: MatDialog,
    private store: Store,
    private notificationService: NotificationService,
  ) {
    this.store.dispatch(new InitCart(false, false, true));
  }

  get checkboxConfirm(): boolean {
    return this.confirmationCheckbox;
  }

  ngOnInit(): void {
    this.selectedPermission = this.invitation.extras?.full_access ? 'full' : 'limited';
    this.selectedAccount = null;
    this.selectedPayment = this.invitation.extras?.has_customer_payment_method ? 'customer' : 'partner';

    switch (this.invitation.status) {
      case 'pending':
        this.currentInvitationStep = this.invitationStep.invitationB2bSelectAccount;
        break;
      case 'accepted':
        this.currentInvitationStep = this.invitationStep.invitationB2bAlreadyAccepted;
        break;
      case 'rejected':
        this.currentInvitationStep = this.invitationStep.invitationB2bAlreadyRejected;
        break;
      case 'error':
        if (this.invitation.error_type && this.invitation.error_type === 'b2b_wrong_account') {
          this.currentInvitationStep = this.invitationStep.invitationB2bWrongAccount;
        } else if (this.invitation.error_type && this.invitation.error_type === 'b2b_only_for_owners') {
          this.currentInvitationStep = this.invitationStep.invitationB2bOnlyForOwners;
        } else {
          window.location.assign('auth/logout?with_login_redirect=1&redirect=' + window?.['ENDPOINTS']?.initial);
        }
        break;
      default:
        this.currentInvitationStep = this.invitationStep.invitationB2bSelectAccount;
        break;
    }
    // this.currentInvitationStep = this.invitationStep.invitationB2bSelectAccount;
  }

  getAcceptCheckboxMessage(): string {
    return translate('J\'accepte de donner a $orga$ la gestion des produits de mon organisation et j\'accepte les $cgu$', {
      orga: this.invitation.account.organization_name,
      cgu: `
        <a
        class="link blue"
        href="https://www.infomaniak.com/fr/cgv/politique-de-confidentialite"
        target=\'_blank\'
        >
          ${translate('conditions generales')}
        </a>`
    });
  }

  rejectInvitation(): void {
    this.rejectLoading = true;
    this.invitationB2bClientService.rejectInvitation(this.selectedAccount.id)
        .then((response) => {
          this.currentInvitationStep = this.invitationStep.invitationB2bRejected;
        }).catch((error) => {
          if (error.error.error.code === 'object_not_found') {
            this.notificationService.error(translate('Cette invitation n\'est plus valide ou n\'existe plus.'));
          } else {
            this.configService.displayErrors(error);
          }
        })
        .finally(() => {
          this.rejectLoading = false;
        });
  }

  acceptInvitation(): void {
    this.acceptLoading = true;

    this.invitationB2bClientService.acceptInvitation(
          this.selectedAccount.id,
          this.selectedPermission === 'limited' ? false : true,
          this.selectedPayment === 'customer' ? true : false,
        )
        .then((response) => {
          this.partnershipId = response.data;
          this.currentInvitationStep = this.invitationStep.invitationB2bAccepted;
        }).catch((error) => {
          if (error.error.error.code === 'object_not_found') {
            this.notificationService.error(translate('Cette invitation n\'est plus valide ou n\'existe plus.'));
          } else {
            this.configService.displayErrors(error);
          }
        })
        .finally(() => {
          this.acceptLoading = false;
        });
  }

  onSelectedAccount(account): void {
    this.selectedAccount = account;
    this.currentInvitationStep = this.invitationStep.invitationB2bInit;
  }

  onSelectedPermission(permission): void {
    this.selectedPermission = permission;
  }

  onSelectedPayment(payment): void {
    this.selectedPayment = payment;
  }

  nextStep(): void {
    this.currentInvitationStep = this.invitationStep.invitationB2bSelectPayment;
  }

  onChangeCheckbox(event: { checked: boolean; }): void {
    this.confirmationCheckbox = event.checked;
  }
}
